import type { CredentialType } from '@seek/ca-myprofile-utils';

import type {
  CertsyLinkAction,
  CertsyLinkPosition,
} from 'src/modules/analytics/certsy/eventNames';
import type { Action } from 'src/types';

const CERTSY_ACTIONS = ['CERTSY_LINK_CLICKED'] as const;
export type CertsyActions = (typeof CERTSY_ACTIONS)[number];

const CERTSY_SECTIONS = ['next role', 'education', 'licence'] as const;
export type CertsySections = (typeof CERTSY_SECTIONS)[number];

export type CertsyAction = Action<'CERTSY_LINK_CLICKED'> & {
  payload: {
    linkUrl?: string;
    linkAction: CertsyLinkAction;
    linkPosition: CertsyLinkPosition;
    credentialType: CredentialType;
    currentPageSection: CertsySections;
  };
};

export const certsyLinkClicked = ({
  linkUrl,
  linkAction,
  linkPosition,
  credentialType,
  currentPageSection,
}: {
  linkUrl?: string;
  linkAction: CertsyLinkAction;
  linkPosition: CertsyLinkPosition;
  credentialType: CredentialType;
  currentPageSection: CertsySections;
}): CertsyAction => ({
  type: 'CERTSY_LINK_CLICKED',
  payload: {
    linkUrl,
    linkAction,
    linkPosition,
    credentialType,
    currentPageSection,
  },
});
